import styled from 'styled-components'

export const CardPlaceholder = styled.div`
  width: 100%;
  height: 500px;
  background-color: aliceblue;
  border-radius: 16px;
  margin: 24px 0;
  padding: 16px;
`

export const ImgPlaceholder = styled.div`
  background-color: #dddddd;
  height: 250px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`
